import { AxiosInstance } from 'axios'

export function parameterEndpoints(apiClient: AxiosInstance) {
  return {
    async get<T = unknown>(slug: string): Promise<T> {
      const res = (await apiClient.get(`get-parameter/${slug}`)) as Record<string, unknown>
      const [entry] = Object.entries(res)
      return entry[1] as T
    },
    getMultiple<T extends Record<string, unknown> = Record<string, unknown>>(slugs: string[]): Promise<T> {
      return apiClient.get(`get-parameter/${slugs.join(',')}`)
    },
    async getWithoutLogin<T = unknown>(slug: string, pharmaceuticalId: number): Promise<T> {
      const res = (await apiClient.get(`get-parameter/${pharmaceuticalId}/${slug}`)) as Record<string, unknown>
      const [entry] = Object.entries(res)
      return entry[1] as T
    },
    getMultipleWithoutLogin<T extends Record<string, unknown> = Record<string, unknown>>(
      slugs: string[],
      pharmaceuticalId: number,
    ): Promise<T> {
      return apiClient.get(`get-parameter/${pharmaceuticalId}/${slugs.join(',')}`)
    },
  }
}
